import Dropdown from "bootstrap/js/dist/dropdown";

export default function setupLanguageSwitcher() {
    const dropdownMenuItemList = document.querySelector('.links');
    
    const dropdownTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="dropdown"]')
    );
    dropdownTriggerList.forEach(function (el) {
        const linksClone = dropdownMenuItemList.cloneNode(true);
        linksClone.setAttribute('aria-labelledby', 'block-languageswitcher');
        linksClone.setAttribute('id', 'languages-dropdown-menu');
        linksClone.classList.add('dropdown-menu');
        linksClone.classList.add('links-show');
        el.insertAdjacentElement('afterend', linksClone);
        el.textContent = document.documentElement.lang?.toUpperCase() || 'EN';
        new Dropdown(el);
    });
    if(!!dropdownMenuItemList){
        dropdownMenuItemList.remove()
    }
}